import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Res, Permission } from 'core/api';
import * as TakeOutOrderStore from './TakeOutOrderStore';

import { Command } from 'pos/common';
import { SalesOrderModel } from './SalesOrderModel';
import { Message } from 'core/ui-next/modal';

type Params = {
	order: SalesOrderModel,
	// En el futuro, cuando podamos cancelar pedidos que no sean de Delivery, hace falta poder
	// indicar que hay que dejar los pagos a 0 primero
	allowCancelWithPreviousPayments: boolean
};

declare global {
	interface CommandType {
		cancelTakeOutOrder: (params: Params) => Promise<Result>
	}
}

Command.register('cancelTakeOutOrder', Preconditions.and(Preconditions.ensure(Permission.SalesOrder_Cancel), Preconditions.ensureIsNotLite), async ({ order, allowCancelWithPreviousPayments }: Params): Promise<Result> => {
	const result = await Message.confirm(Res.Msg.MSG_CONFIRM_CANCEL_SALES_ORDER());
	if (!result.ok)
		return Result.error();

	if (!allowCancelWithPreviousPayments && order.PrepaidAmount !== 0) {
		await Message.show(Res.Msg.MSG_CANNOT_CANCEL_A_SALES_ORDER_WITH_BALANCE_OTHER_THAN_ZERO());
		return Result.error();
	}
	return await TakeOutOrderStore.cancel(order.Id);
});
